import DEFAULT_COLUMNS from 'src/constants/columns';
import { ENTITIES, GridColumns } from 'src/models/QuerybuilderModel';

const getDefaultColumns = (entity: ENTITIES): GridColumns => (
  (DEFAULT_COLUMNS as Record<string, GridColumns>)[entity] ?? []
);

/**
 * Layout presets only store column layout (visibility, order, width). The column
 * definition (notably its type) always comes from DEFAULT_COLUMNS, so preset
 * columns saved by older versions must be hydrated before being displayed.
 * Duplicated fields are collapsed into a single entry.
 */
export const normalizePresetColumns = (
  entity: ENTITIES,
  presetColumns?: GridColumns,
): GridColumns | undefined => {
  if (!presetColumns) return presetColumns;

  const defaultColumns = getDefaultColumns(entity);
  const normalizedColumns: GridColumns = [];

  presetColumns.forEach((presetColumn) => {
    const defaultColumn = presetColumn.field.startsWith('custom_fields.')
      ? undefined
      : defaultColumns.find((column) => column.field === presetColumn.field);

    const normalizedColumn = defaultColumn
      ? {
        ...presetColumn,
        type: defaultColumn.type,
        resizable: defaultColumn.resizable,
      }
      : presetColumn;

    const existingIndex = normalizedColumns.findIndex(
      (column) => column.field === normalizedColumn.field,
    );

    if (existingIndex === -1) {
      normalizedColumns.push(normalizedColumn);
    } else {
      normalizedColumns[existingIndex] = {
        ...normalizedColumns[existingIndex],
        ...normalizedColumn,
      };
    }
  });

  return normalizedColumns;
};
